/**
 * contexts.js
 * Lightweight React contexts so deeply-nested editors (e.g. column slot editors)
 * can access state that the top-level PropertiesPanel knows about:
 *  - the list of saved custom elements (for picking them in column slots)
 *  - the current page settings (for width-warning math)
 *
 * Using context avoids prop-drilling through 4+ layers of editors.
 */
import { createContext, useContext } from "react";

const CustomElementsContext = createContext([]);
const PageSettingsContext = createContext({});

export function CustomElementsProvider({ value, children }) {
  return <CustomElementsContext.Provider value={value || []}>{children}</CustomElementsContext.Provider>;
}

export function PageSettingsProvider({ value, children }) {
  return <PageSettingsContext.Provider value={value || {}}>{children}</PageSettingsContext.Provider>;
}

export function useCustomElementsList() {
  return useContext(CustomElementsContext);
}

export function usePageSettings() {
  return useContext(PageSettingsContext);
}
